<template>
  <v-row>
    <v-col cols="12" class="pa-0">
      <survey-queue
        v-if="taskId == $enums.taskTypes.SURVEY_TO_TAKE"
        hide-header
        redirect
      ></survey-queue>
      <pulse-queue
        v-if="taskId == $enums.taskTypes.PULSE_TO_ANSWER"
      ></pulse-queue>
      <resource-queue
        v-else-if="taskId == $enums.taskTypes.RESOURCE_TO_READ"
        hide-header
      ></resource-queue>
      <pending-review-list
        v-else-if="taskId == $enums.taskTypes.REVIEWS_AVAILABLE"
        hide-header
      ></pending-review-list>
      <unfinished-check-in-queue
        v-else-if="taskId == $enums.taskTypes.CHECK_IN_STARTED_BUT_NOT_FINISHED"
      ></unfinished-check-in-queue>
      <annual-review-ready-queue
        v-else-if="taskId == $enums.taskTypes.ANNUAL_REVIEW_AVAILABLE"
      ></annual-review-ready-queue>
      <annual-review-signoff-ready-queue
        v-else-if="taskId == $enums.taskTypes.ANNUAL_REVIEW_SIGNOFF_READY"
      ></annual-review-signoff-ready-queue>
      <pulse-feedback
        v-else-if="taskId == $enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE"
      ></pulse-feedback>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyQueue from "@/components/surveys/SurveyQueue";
import PulseQueue from "@/components/pulse/PulseQueue";
import ResourceQueue from "@/components/resources/ResourceQueue";
import PendingReviewList from "@/components/reviews/PendingReviewList";
import UnfinishedCheckInQueue from "@/components/checkin/UnfinishedCheckInQueue";
import AnnualReviewReadyQueue from "@/components/annualreviews/AnnualReviewReadyQueue";
import AnnualReviewSignoffReadyQueue from "@/components/annualreviews/AnnualReviewSignoffReadyQueue";
import PulseFeedback from "@/components/pulse/PulseFeedback";
export default {
  name: "TaskDetails",
  components: {
    SurveyQueue,
    PulseQueue,
    ResourceQueue,
    PendingReviewList,
    UnfinishedCheckInQueue,
    AnnualReviewReadyQueue,
    AnnualReviewSignoffReadyQueue,
    PulseFeedback
  },
  props: { taskId: { type: Number } },
  data: () => ({}),
  computed: {
    ...mapGetters({})
  },
  watch: {},
  created() {},
  methods: {}
};
</script>
